import styled from 'styled-components';
import theme from '../../styles/theme';

export const CustomSelect = styled.select`
  display: flex;
  flex: 1;
  height: 45px;
  min-height: 45px;
  max-height: 45px;
  border-radius: 1px;
  border: 1px solid ${theme.inputBorder};
  padding: 0 20px;
  background-color: transparent;
  font-size: 16px;
  margin: ${({ margin, right }) => {
    if (margin) {
      if (right) {
        return '0 10px 0 0';
      }

      return '0 0 0 10px';
    }
    return '0';
  }};

  @media (min-width: 1025px) {
    max-width: 165px;
  }

  @media (max-width: 640px) {
    margin: 0px;
  }

  :focus {
    border: 1px solid ${theme.inputActiveBorder};
    background-color: ${theme.inputBackground};
  }
`;
